import {HTTP} from "../http";

export default {
    namespaced: true,

    state: {
        loading: false,
        categories: [],
        active: null
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },

        setCategories(state, categories) {
            state.categories = categories;
        },

        setActive(state, category) {
            state.active = category;
        },

        createBlank(state) {
            state.active = {
                name: '',
                imageId: null
            };
        },

        setActiveImage(state, imageId) {
            if(state.active !== null) {
                state.active.imageId = imageId;
            }
        }
    },

    actions: {
        load({ commit }) {
            commit('setLoading', true);

            return HTTP.get('/categories')
                .then(resp => {
                    commit('setCategories', resp.data);
                    commit('setLoading', false);
                })
                .catch(err => commit('error/set', err.response, {root:true}))
        },

        save(context, category) {
            if(category.id !== undefined) {
                return HTTP.post('/categories/' + category.id, category)
                    .catch(err => context.commit('error/set', err.response, { root: true }));
            } else {
                return HTTP.post('/categories', category)
                    .catch(err => context.commit('error/set', err.response, { root: true }));
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/admin-categores.js